import { render, staticRenderFns } from "./addCoachDialog.vue?vue&type=template&id=13d5fcf9&scoped=true&"
import script from "./addCoachDialog.vue?vue&type=script&lang=js&"
export * from "./addCoachDialog.vue?vue&type=script&lang=js&"
import style0 from "./addCoachDialog.vue?vue&type=style&index=0&id=13d5fcf9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d5fcf9",
  null
  
)

export default component.exports